import { type ChainId, chains as chainMetadata } from '@endure/chains';

import { Icon, Toggle } from 'components';
import { useTranslation } from 'libs/translations';
import { store } from 'store';

export interface GaslessTransactionSettingProps {
  chainId: ChainId;
}

export const GaslessTransactionSetting: React.FC<GaslessTransactionSettingProps> = ({
  chainId,
}) => {
  const { t } = useTranslation();

  const userSettings = store.use.userSettings()[chainId];
  const setUserSettings = store.use.setUserSettings();

  const chainName = chainMetadata[chainId].name;

  const toggle = () =>
    setUserSettings({
      settings: {
        gaslessTransactions: !userSettings?.gaslessTransactions,
      },
      chainIds: [chainId],
    });

  return (
    <div className="flex items-center gap-x-3 justify-between">
      <div className="flex flex-col gap-y-1">
        <div className="flex flex-col gap-y-3 xl:gap-y-0 xl:flex-row xl:gap-x-1 xl:items-center">
          <Icon name="gasSlashed" className="size-4 text-success" />

          <p className="text-sm">
            {t('layout.menu.settings.gasLessTransactions.label', {
              chainName,
            })}
          </p>
        </div>
      </div>

      <Toggle onChange={toggle} value={userSettings?.gaslessTransactions ?? false} />
    </div>
  );
};
